import React, { useState, useEffect } from 'react'
import { AnimatePresence } from 'framer-motion'
import Navbar from '../components/Navbar'
import LoadingScreen from '../components/LoadingScreen'
import Hero from '../components/Hero'
import ImpactDashboard from '../components/ImpactDashboard'
import HeritageSection from '../components/HeritageSection'
import MissionsSection from '../components/MissionsSection'
import BookingForm from '../components/BookingForm'
import VolunteerForm from '../components/VolunteerForm'
import GallerySection from '../components/GallerySection'
import TestimonialSection from '../components/TestimonialSection'
import LeaderboardSection from '../components/LeaderboardSection'
import FinalCTA from '../components/FinalCTA'
import Footer from '../components/Footer'

const Home = ({ isDark, setIsDark }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [scrollProgress, setScrollProgress] = useState(0)

  useEffect(() => {
    // Handle scroll progress
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight
      const scrolled = (window.scrollY / totalHeight) * 100
      setScrollProgress(scrolled)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className="bg-white text-gray-800 overflow-x-hidden min-h-screen">
      {/* Scroll Progress Bar */}
      <div
        className="fixed top-0 left-0 h-1 bg-gradient-to-r from-accent-maroon to-accent-maroonDark z-50 transition-all duration-300"
        style={{ width: `${scrollProgress}%` }}
      />

      {/* Loading Screen */}
      <AnimatePresence>
        {isLoading && <LoadingScreen onLoadingComplete={() => setIsLoading(false)} />}
      </AnimatePresence>

      {!isLoading && (
        <>
          {/* Navbar */}
          <Navbar />

          {/* Main Content */}
          <main>
            {/* Hero Section */}
            <Hero />

            {/* Impact Dashboard */}
            <ImpactDashboard />

            {/* Heritage Section */}
            <HeritageSection />

            {/* Missions */}
            <MissionsSection />

            {/* Booking Form */}
            <BookingForm />

            {/* Volunteer Form */}
            <VolunteerForm />

            {/* Gallery */}
            <GallerySection />

            {/* Testimonials */}
            <TestimonialSection />

            {/* Leaderboard */}
            <LeaderboardSection />

            {/* Final CTA */}
            <FinalCTA />
          </main>

          {/* Footer */}
          <Footer />
        </>
      )}
    </div>
  )
}

export default Home
